import { render, staticRenderFns } from "./ReporteClientes.vue?vue&type=template&id=3936b6cd&scoped=true&"
import script from "./ReporteClientes.vue?vue&type=script&lang=js&"
export * from "./ReporteClientes.vue?vue&type=script&lang=js&"
import style0 from "./ReporteClientes.vue?vue&type=style&index=0&id=3936b6cd&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3936b6cd",
  null
  
)

export default component.exports